// crm namespace — CRM refusal codes and read/write failures (admin/crm/api/crmErrors.js).
// Flat dotted keys, the same set in fr / en / es (i18n/__tests__/symmetry.test.js).
export default {
  fr: {
    "errors.attendanceLocked": "Cette séance est trop ancienne pour être modifiée.",
    "errors.attendanceNotApplicable": "La présence ne peut pas être enregistrée pour ce rendez-vous.",
    "errors.attendanceTooEarly": "La séance n'a pas encore commencé.",
    "errors.bookingNotForClient": "Cette séance n'appartient pas à ce client.",
    "errors.bulkTooLarge": "Sélectionnez 10 000 clients au maximum.",
    "errors.clientExists": "Un client avec cette adresse existe déjà.",
    "errors.nudgeClosed": "Cette suggestion a déjà été traitée.",
    "errors.encourageMessageInvalid": "Le message doit contenir entre 1 et 2000 caractères.",
    "errors.clientNotConsented": "Ce client n'a pas consenti aux e-mails.",
    "errors.clientNotFound": "Aucun client n'a cette adresse e-mail.",
    "errors.confirmNameMismatch": "Le nom saisi ne correspond pas.",
    "errors.dailySendCap": "La limite d'envoi du jour est atteinte. Elle se réinitialise à minuit.",
    "errors.emailInvalid": "Vérifiez l'adresse e-mail.",
    "errors.encryptionUnavailable": "Les notes privées sont indisponibles pour le moment. Réessayez plus tard.",
    "errors.exportFailed": "Le fichier n'a pas pu être préparé. Réessayez.",
    "errors.importEmailUnmapped": "Associez d'abord une colonne à l'e-mail.",
    "errors.importEmpty": "Ce fichier ne contient aucune ligne à importer.",
    "errors.importFailed": "Ce fichier n'a pas pu être lu. Vérifiez qu'il s'agit d'un CSV ou d'un XLSX.",
    "errors.importTooManyRows": "Ce fichier dépasse 10 000 lignes. Divisez-le et importez chaque partie.",
    "errors.loadFailed": "Impossible de charger ces informations.",
    "errors.ownerOnly": "Seul le titulaire du cabinet peut faire cela.",
    "errors.packExhausted": "Ce forfait n'a plus de séances.",
    "errors.packExpired": "Ce forfait a expiré.",
    "errors.packNotForService": "Ce forfait ne s'applique pas à ce service.",
    "errors.reminderNotApplicable": "Aucun rappel ne peut être envoyé pour ce rendez-vous.",
    "errors.saveFailed": "Impossible d'enregistrer. Réessayez.",
    "errors.serviceNotBookable": "Ce service ne peut pas être réservé d'ici.",
    "errors.timeUnavailable": "Ce créneau vient d'être pris. Choisissez-en un autre.",
    "errors.uploadFailed": "Le fichier n'a pas pu être envoyé.",
    "errors.viewNameTaken": "Une vue enregistrée porte déjà ce nom.",
    "errors.importFileTooLarge": "Ce fichier est trop volumineux. Divisez-le et importez chaque partie.",
    "errors.importUnreadable": "Ce fichier est illisible. Enregistrez-le en CSV ou XLSX et réessayez.",
    "errors.importNotMapped": "Associez les colonnes avant de continuer.",
    "errors.importNotCompleted": "Cet import n'est pas encore terminé.",
    "errors.importMappingInvalid": "Cette association de colonnes n'est pas valable : chaque champ CRM ne peut être choisi qu'une fois, et l'e-mail est obligatoire.",
    "errors.reminderSendUnavailable": "Le rappel n'a pas pu être envoyé pour le moment. Réessayez dans quelques minutes.",
    "errors.packBalanceNotFound": "Ce solde de forfait n'existe plus. Rechargez la page.",
    "errors.systemTriggerLocked": "Le déclencheur d'une séquence prête à l'emploi ne peut pas être modifié.",
    "errors.triggerInvalid": "Le déclencheur ou ses options ne sont pas valides. Choisissez-les à nouveau, puis enregistrez.",
    "errors.systemSequence": "Cette séquence prête à l'emploi ne peut pas être supprimée.",
    "errors.mergeFieldUnknown": "Ce champ de fusion n'existe pas.",
    "errors.offsetAnchorInvalid": "Ce délai ne s'applique pas à ce déclencheur.",
    "errors.sequenceEmpty": "Ajoutez au moins une étape avant d'activer cette séquence.",
    "errors.audienceChanged": "Le nombre de destinataires a changé depuis l'aperçu. Vérifiez avant d'envoyer.",
    "errors.domainInvalid": "Ce nom de domaine n'est pas valable.",
    "errors.domainInUse": "Ce domaine est déjà utilisé par un autre cabinet.",
    "errors.resendUnavailable": "Le service d'envoi est indisponible pour le moment. Réessayez plus tard.",
    "errors.promotionAlreadyActive": "Cet élément est déjà promu.",
    "errors.boosterRequired": "Il faut d'abord activer le module de mise en avant.",
    "errors.memberExists": "Cette personne fait déjà partie de l'équipe.",
    "errors.cannotInviteOwner": "Le titulaire du cabinet n'a pas besoin d'invitation.",
    "errors.inviteEmailMismatch": "Cette invitation a été envoyée à une autre adresse e-mail.",
    "errors.inviteExpired": "Cette invitation a expiré.",
    "errors.unsupportedFileType": "Type de fichier non pris en charge : images, vidéos, PDF, DOCX, XLSX, PPTX et texte brut uniquement.",
    "errors.fileTooLarge": "Le fichier est trop volumineux (25 Mo maximum).",
    "errors.mediaNotFound": "Le fichier média est introuvable.",
    "errors.documentNotFound": "Ce document n'existe plus.",
  },
  en: {
    "errors.attendanceLocked": "This session is too old to change.",
    "errors.attendanceNotApplicable": "Attendance cannot be recorded for this booking.",
    "errors.attendanceTooEarly": "The session has not started yet.",
    "errors.bookingNotForClient": "This session does not belong to this client.",
    "errors.bulkTooLarge": "Select 10,000 clients or fewer.",
    "errors.clientExists": "A client with this email already exists.",
    "errors.nudgeClosed": "This nudge was already handled.",
    "errors.encourageMessageInvalid": "The message must be 1 to 2,000 characters.",
    "errors.clientNotConsented": "This client has not consented to emails.",
    "errors.clientNotFound": "No client has this email address.",
    "errors.confirmNameMismatch": "The name typed does not match.",
    "errors.dailySendCap": "Today's sending limit is reached. It resets at midnight.",
    "errors.emailInvalid": "Check the email address.",
    "errors.encryptionUnavailable": "Private notes are unavailable right now. Try again later.",
    "errors.exportFailed": "The file could not be prepared. Try again.",
    "errors.importEmailUnmapped": "Map a column to email first.",
    "errors.importEmpty": "This file has no rows to import.",
    "errors.importFailed": "This file could not be read. Check it is a CSV or XLSX file.",
    "errors.importTooManyRows": "This file has more than 10,000 rows. Split it and import each part.",
    "errors.loadFailed": "This could not be loaded.",
    "errors.ownerOnly": "Only the practice owner can do this.",
    "errors.packExhausted": "This pack has no sessions left.",
    "errors.packExpired": "This pack has expired.",
    "errors.packNotForService": "This pack is not for this service.",
    "errors.reminderNotApplicable": "No reminder can be sent for this booking.",
    "errors.saveFailed": "This could not be saved. Try again.",
    "errors.serviceNotBookable": "This service cannot be booked from here.",
    "errors.timeUnavailable": "That time was just taken. Pick another one.",
    "errors.uploadFailed": "The file could not be uploaded.",
    "errors.viewNameTaken": "A saved view already has this name.",
    "errors.importFileTooLarge": "This file is too large. Split it and import each part.",
    "errors.importUnreadable": "This file could not be read. Save it as CSV or XLSX and try again.",
    "errors.importNotMapped": "Map the columns before going on.",
    "errors.importNotCompleted": "This import has not finished yet.",
    "errors.importMappingInvalid": "This column mapping cannot be used: each CRM field can be chosen once, and email is required.",
    "errors.reminderSendUnavailable": "The reminder could not be sent right now. Try again in a few minutes.",
    "errors.packBalanceNotFound": "This pack balance no longer exists. Reload the page.",
    "errors.systemTriggerLocked": "A pre-built sequence's trigger cannot be changed.",
    "errors.triggerInvalid": "The trigger or its options are not valid. Choose them again, then save.",
    "errors.systemSequence": "This pre-built sequence cannot be deleted.",
    "errors.mergeFieldUnknown": "That merge field does not exist.",
    "errors.offsetAnchorInvalid": "That timing does not apply to this trigger.",
    "errors.sequenceEmpty": "Add at least one step before activating this sequence.",
    "errors.audienceChanged": "The recipient count changed since the preview. Check before sending.",
    "errors.domainInvalid": "That domain name is not valid.",
    "errors.domainInUse": "That domain is already in use by another practice.",
    "errors.resendUnavailable": "The sending service is unavailable right now. Try again later.",
    "errors.promotionAlreadyActive": "This item is already promoted.",
    "errors.boosterRequired": "The promotion module needs to be turned on first.",
    "errors.memberExists": "This person is already on the team.",
    "errors.cannotInviteOwner": "The practice owner does not need an invite.",
    "errors.inviteEmailMismatch": "This invite was sent to a different email address.",
    "errors.inviteExpired": "This invite has expired.",
    "errors.unsupportedFileType": "Unsupported file type: images, videos, PDF, DOCX, XLSX, PPTX and plain text only.",
    "errors.fileTooLarge": "The file is too large (maximum 25 MB).",
    "errors.mediaNotFound": "The media file could not be found.",
    "errors.documentNotFound": "This document no longer exists.",
  },
  es: {
    "errors.attendanceLocked": "Esta sesión es demasiado antigua para cambiarla.",
    "errors.attendanceNotApplicable": "No se puede registrar la asistencia de esta reserva.",
    "errors.attendanceTooEarly": "La sesión aún no ha empezado.",
    "errors.bookingNotForClient": "Esta sesión no pertenece a este cliente.",
    "errors.bulkTooLarge": "Selecciona 10.000 clientes como máximo.",
    "errors.clientExists": "Ya existe un cliente con este correo.",
    "errors.nudgeClosed": "Esta sugerencia ya se atendió.",
    "errors.encourageMessageInvalid": "El mensaje debe tener entre 1 y 2000 caracteres.",
    "errors.clientNotConsented": "Este cliente no ha dado su consentimiento a los correos.",
    "errors.clientNotFound": "Ningún cliente tiene este correo.",
    "errors.confirmNameMismatch": "El nombre escrito no coincide.",
    "errors.dailySendCap": "Se ha alcanzado el límite de envíos de hoy. Se reinicia a medianoche.",
    "errors.emailInvalid": "Revisa la dirección de correo.",
    "errors.encryptionUnavailable": "Las notas privadas no están disponibles ahora. Inténtalo más tarde.",
    "errors.exportFailed": "No se ha podido preparar el archivo. Inténtalo de nuevo.",
    "errors.importEmailUnmapped": "Asigna primero una columna al correo.",
    "errors.importEmpty": "Este archivo no tiene filas para importar.",
    "errors.importFailed": "No se ha podido leer el archivo. Comprueba que sea un CSV o XLSX.",
    "errors.importTooManyRows": "Este archivo tiene más de 10.000 filas. Divídelo e importa cada parte.",
    "errors.loadFailed": "No se ha podido cargar.",
    "errors.ownerOnly": "Solo la persona titular de la consulta puede hacerlo.",
    "errors.packExhausted": "A este bono no le quedan sesiones.",
    "errors.packExpired": "Este bono ha caducado.",
    "errors.packNotForService": "Este bono no es para este servicio.",
    "errors.reminderNotApplicable": "No se puede enviar un recordatorio para esta reserva.",
    "errors.saveFailed": "No se ha podido guardar. Inténtalo de nuevo.",
    "errors.serviceNotBookable": "Este servicio no se puede reservar desde aquí.",
    "errors.timeUnavailable": "Esa hora acaba de ocuparse. Elige otra.",
    "errors.uploadFailed": "No se ha podido subir el archivo.",
    "errors.viewNameTaken": "Ya existe una vista guardada con este nombre.",
    "errors.importFileTooLarge": "Este archivo es demasiado grande. Divídelo e importa cada parte.",
    "errors.importUnreadable": "No se ha podido leer este archivo. Guárdalo como CSV o XLSX y vuelve a intentarlo.",
    "errors.importNotMapped": "Asigna las columnas antes de continuar.",
    "errors.importNotCompleted": "Esta importación aún no ha terminado.",
    "errors.importMappingInvalid": "Esta asignación de columnas no es válida: cada campo del CRM solo puede elegirse una vez y el correo es obligatorio.",
    "errors.reminderSendUnavailable": "No se ha podido enviar el recordatorio ahora. Inténtalo en unos minutos.",
    "errors.packBalanceNotFound": "Este saldo de bono ya no existe. Recarga la página.",
    "errors.systemTriggerLocked": "El desencadenante de una secuencia predefinida no se puede cambiar.",
    "errors.triggerInvalid": "El desencadenante o sus opciones no son válidos. Vuelve a elegirlos y guarda.",
    "errors.systemSequence": "Esta secuencia predefinida no se puede eliminar.",
    "errors.mergeFieldUnknown": "Ese campo de combinación no existe.",
    "errors.offsetAnchorInvalid": "Ese plazo no se aplica a este desencadenante.",
    "errors.sequenceEmpty": "Añade al menos un paso antes de activar esta secuencia.",
    "errors.audienceChanged": "El número de destinatarios cambió desde la vista previa. Compruébalo antes de enviar.",
    "errors.domainInvalid": "Ese nombre de dominio no es válido.",
    "errors.domainInUse": "Ese dominio ya lo usa otra consulta.",
    "errors.resendUnavailable": "El servicio de envío no está disponible en este momento. Inténtalo más tarde.",
    "errors.promotionAlreadyActive": "Este elemento ya está promocionado.",
    "errors.boosterRequired": "Primero hay que activar el módulo de promoción.",
    "errors.memberExists": "Esta persona ya forma parte del equipo.",
    "errors.cannotInviteOwner": "La persona titular de la consulta no necesita invitación.",
    "errors.inviteEmailMismatch": "Esta invitación se envió a otro correo electrónico.",
    "errors.inviteExpired": "Esta invitación ha caducado.",
    "errors.unsupportedFileType": "Tipo de archivo no admitido: solo imágenes, vídeos, PDF, DOCX, XLSX, PPTX y texto sin formato.",
    "errors.fileTooLarge": "El archivo es demasiado grande (máximo 25 MB).",
    "errors.mediaNotFound": "No se ha encontrado el archivo multimedia.",
    "errors.documentNotFound": "Este documento ya no existe.",
  },
};
